import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

interface PowerIconProps {
    width?: number | string;
    height?: number | string;
    className?: string;
}

const PowerIcon = ({ width = 24, height = 24, className }: PowerIconProps) => {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M4.7998 14.4003L13.1998 1.20032V10.8003H19.1998L10.7998 22.8003V14.4003H4.7998Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

interface BatteryIconProps {
    width?: number | string;
    height?: number | string;
    className?: string;
}

const BatteryIcon = ({ width = 32, height = 32, className }: BatteryIconProps) => {
    return (
        <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M27.4545 5.33325H4.54545C4.24421 5.33325 4 5.58909 4 5.90468V12.7618C4 13.0774 4.24421 13.3333 4.54545 13.3333H27.4545C27.7558 13.3333 28 13.0774 28 12.7618V5.90468C28 5.58909 27.7558 5.33325 27.4545 5.33325Z"
                stroke="white"
                strokeWidth="2.13333"
            />
            <path d="M9.45508 13.3333V18.6666" stroke="white" strokeWidth="2.13333" strokeLinecap="square" />
            <path
                d="M27.4545 18.6667H4.54545C4.24421 18.6667 4 18.9226 4 19.2382V26.0953C4 26.4109 4.24421 26.6667 4.54545 26.6667H27.4545C27.7558 26.6667 28 26.4109 28 26.0953V19.2382C28 18.9226 27.7558 18.6667 27.4545 18.6667Z"
                stroke="white"
                strokeWidth="2.13333"
            />
        </svg>
    );
};

export default function Highlights() {
    const { useLang } = useGlobal();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    return (
        <div className={`${css.highlights} dpu-detail-highlights`}>
            <h3 className={css.title}>{t('sec_highlights_title')}</h3>

            <div className="container">
                <div className="item a">
                    <div className={css.itemAContent}>
                        <h2 className={css.commonTitle}>{t('sec_highlights_1_title')}</h2>
                        <p className={css.commonDesc}>{t('sec_highlights_1_desc')}</p>
                        <div className={css.itemASpecs}>
                            <div className={css.specItem}>
                                <span className={css.specIcon}>
                                    <PowerIcon className={css.powerIconSvg} />
                                </span>
                                <span className={css.specText}>{t('sec_highlights_1_spec1_title')}</span>
                            </div>
                            <div className={css.specItem}>
                                <span className={css.specIcon}>
                                    <BatteryIcon className={css.batteryIconSvg} />
                                </span>
                                <span className={css.specText}>{t('sec_highlights_1_spec2_title')}</span>
                            </div>
                        </div>
                    </div>
                    <EFPicture
                        src="https://websiteoss.ecoflow.com/upload/image/1770546220872/1030%E4%B9%9D%E5%9D%97%E7%94%B5%E6%B1%A0%E7%BB%99%E5%85%A8%E5%B1%8B%E4%BE%9B%E7%94%B5%201.png"
                        alt="us-img"
                        className="item-a"
                    />
                </div>
                <div className="item b">
                    <div className={css.itemBContent}>
                        <div className={css.itemBTopText}>
                            <p className={css.commonTitle}>{t('sec_highlights_2_title1')}</p>
                            <p className={css.commonTitle}>{t('sec_highlights_2_title2')}</p>
                        </div>
                        {/* <div className={css.itemBCenterText}>
                            <span className={css.itemBNumber}>7</span>
                            <span className={css.itemBDay}>-Day</span>
                        </div> */}
                    </div>
                    <EFPicture
                        src="https://websiteoss.ecoflow.com/upload/image/1770792797878/KSP02%20(1).png"
                        srcPad="https://websiteoss.ecoflow.com/upload/image/1770630361563/mob%20ksp02%20(2)%20(1).png"
                        srcMobile="https://websiteoss.ecoflow.com/upload/image/1770630361563/mob%20ksp02%20(2)%20(1).png"
                        alt="us-img"
                        className="item-a"
                    />
                </div>
                <div className="item c">
                    <div className={css.itemCContent}>
                        <h3 className={css.commonTitle}>{t('sec_highlights_3_title')}</h3>
                    </div>
                    <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1770546222490/KSP03%20(1).png" alt="us-img" className="item-a" />
                </div>
                <div className="item d">
                    <div className={css.itemDContent}>
                        <h3 className={css.commonTitle}>
                            {t.rich('sec_highlights_4_title', {
                                bold: (text: string) => <span className={css.boldText}>{text}</span>,
                            })}
                        </h3>
                        <p className={css.commonDesc}>{t('sec_highlights_4_desc')}</p>
                    </div>
                    <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1770546222093/KSP04.png" alt="us-img" className="item-a" />
                </div>
                <div className="item e">
                    <div className={css.itemEContent}>
                        <h3 className={css.commonTitle}>{t('sec_highlights_5_title')}</h3>
                        <p className={css.commonDesc}>{t('sec_highlights_5_desc')}</p>
                    </div>
                    <EFPicture
                        src="https://websiteoss.ecoflow.com/upload/image/1770628479881/KSP05%20(1).png"
                        srcPad="https://websiteoss.ecoflow.com/upload/image/1770630773594/mob%20ksp05%20(1)%20(1).png"
                        srcMobile="https://websiteoss.ecoflow.com/upload/image/1770630773594/mob%20ksp05%20(1)%20(1).png"
                        alt="us-img"
                        className="item-a"
                    />
                </div>
            </div>
        </div>
    );
}
